'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _currency_utility = require('../../../packages/common-utilities/src/currency_utility.js');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _formatted_number = require('./global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _number_utility = require('../../../packages/common-utilities/src/number_utility');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _tooltipText = require('./global_components/tooltipText');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var FundStatsDataPoint = function (_React$Component) {
  _inherits(FundStatsDataPoint, _React$Component);

  function FundStatsDataPoint(props) {
    _classCallCheck(this, FundStatsDataPoint);

    var _this = _possibleConstructorReturn(this, (FundStatsDataPoint.__proto__ || Object.getPrototypeOf(FundStatsDataPoint)).call(this, props));

    _initialiseProps.call(_this);

    _this.datePrefixLabel = _this.props.shouldUseOnForDateLabel ? _string_utility2.default.renderFormattedLabel('On ', 'label-for-on') : _string_utility2.default.renderFormattedLabel('As of ', 'label-for-as-of', { role: _this.props.role });
    _this.renderIcon = _this.renderIcon.bind(_this);
    _this.renderIntraDayNavWithESTTimeZone = _this.renderIntraDayNavWithESTTimeZone.bind(_this);
    _this.renderIntraDayNavWithLocalTimeZone = _this.renderIntraDayNavWithLocalTimeZone.bind(_this);
    _this.doNotRender = _this.doNotRender.bind(_this);
    _this.renderAsOfDateForSingleFundStatsDataPoint = _this.renderAsOfDateForSingleFundStatsDataPoint.bind(_this);
    _this.renderSingleFundStatsDataPoint = _this.renderSingleFundStatsDataPoint.bind(_this);
    _this.handleDisclosureIconClick = _this.handleDisclosureIconClick.bind(_this);
    return _this;
  }

  _createClass(FundStatsDataPoint, [{
    key: 'renderIcon',
    value: function renderIcon(ariaLblTxt) {
      var _this2 = this;

      var _props = this.props,
          breakpoint = _props.breakpoint,
          disclosure = _props.disclosure,
          dataTest = _props.dataTest,
          tooltip = _props.tooltip,
          useTooltipWrapper = _props.useTooltipWrapper;

      if ((0, _functional_utility.isNilOrEmpty)(disclosure)) {
        return null;
      }

      var filteredDisclosures = disclosure.filter(function (d) {
        return !(0, _ramda.isNil)(d);
      });

      if (useTooltipWrapper) {
        return (0, _tooltipText.getDisclaimerText)({
          className: "display-inline",
          text: _react2.default.createElement('span', {
            tabIndex: 0,
            className: "icon-info print-hide margin-left-5",
            role: 'button',
            'aria-label': 'more information about ' + ariaLblTxt,
            'data-testid': 'fund-stats-data-disclosure-icon'
          }),
          tooltipText: filteredDisclosures,
          useOffsetLeftForArrowPosition: true
        });
      }

      return _react2.default.createElement(
        'span',
        { id: 'disclosure-' + dataTest,
          tabIndex: 0,
          ref: function ref(el) {
            return _this2[dataTest] = el;
          },
          className: 'icon-info print-hide vertical-align-top',
          role: 'button',
          'aria-label': 'more information about ' + ariaLblTxt,
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this2, event, _this2.handleDisclosureIconClick.bind(_this2, event, dataTest, disclosure, tooltip, breakpoint, filteredDisclosures));
          },
          onClick: function onClick(event) {
            return _this2.handleDisclosureIconClick(event, dataTest, disclosure, tooltip, breakpoint, filteredDisclosures);
          }
        },
        ' '
      );
    }
  }, {
    key: 'handleDisclosureIconClick',
    value: function handleDisclosureIconClick(event, dataTest, disclosure, tooltip, breakpoint, filteredDisclosures) {
      var el = this[dataTest];
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      var toolTipWidth = void 0,
          toolTipContentWidth = void 0,
          closeTipPosition = void 0,
          toolTipContentScroll = 'hidden';
      if (disclosure[0].length > 380) {
        if (breakpoint > 3) {
          elWidth -= 150;
          toolTipWidth = 570;
          toolTipContentWidth = 530;
          closeTipPosition = 530;
        } else {
          toolTipContentScroll = 'auto';
        }
      }
      if (breakpoint <= 3) {
        toolTipContentScroll = 'auto';
      }
      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - 3,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipContentWidth,
        closeTipPosition: closeTipPosition,
        toolTipContentScroll: toolTipContentScroll
      };

      if (!(0, _ramda.isNil)(tooltip)) {
        tooltip.openTooltip(elOffset, filteredDisclosures, null, true, event);
      }
    }
  }, {
    key: 'doNotRender',
    value: function doNotRender() {
      if (this.props.suppress) {
        return true;
      }
      var value = typeof this.props.value === 'function' ? this.props.value() : this.props.value;
      if (this.props.suppressIfNull && (value === "-" || !this.props.value) && !this.props.intraDayNav) {
        return true;
      }

      return false;
    }
  }, {
    key: 'renderAsOfDateForSingleFundStatsDataPoint',
    value: function renderAsOfDateForSingleFundStatsDataPoint() {
      var _props2 = this.props,
          value = _props2.value,
          date = _props2.date,
          dataTest = _props2.dataTest;

      return value !== "-" && date && _react2.default.createElement(
        'span',
        { className: 'disclaimer font-dark-gray',
          'data-testid': dataTest + '-as-of-date', id: dataTest + '-as-of-date' },
        this.datePrefixLabel,
        _date_formatter2.default.getLocalFormattedDate(date)
      );
    }
  }, {
    key: 'renderSingleFundStatsDataPoint',
    value: function renderSingleFundStatsDataPoint(backgroundRowColor) {
      var isGrouped = false;

      if (!(0, _ramda.isNil)(this.props.isGrouped)) {
        isGrouped = this.props.isGrouped;
      }

      var value = '-';
      if (!(0, _ramda.isNil)(this.props.value)) {
        if (typeof this.props.value === 'function') {
          value = this.props.value();
        } else {
          value = this.props.value;
        }
      }

      return _react2.default.createElement(
        'div',
        { className: 'row ' + (isGrouped ? '' : 'padding-top-10') + ' ' + backgroundRowColor },
        _react2.default.createElement(
          'div',
          { className: 'col-md-12 padding-left-0 padding-right-0 float-none', role: "row" },
          _react2.default.createElement(
            'span',
            {
              className: 'text-left col-xs-7 col-md-7 col-lg-8 col-xlg-7 category white-space-nowrap',
              'data-testid': this.props.dataTest + '-label',
              id: this.props.dataTest + '-label',
              style: { zIndex: 1 },
              role: "rowheader"
            },
            _react2.default.createElement(
              'span',
              { className: 'white-space-default' },
              this.props.label
            ),
            '\xA0',
            this.renderIcon(this.props.labelText),
            _react2.default.createElement('br', null),
            this.renderAsOfDateForSingleFundStatsDataPoint()
          ),
          _react2.default.createElement(
            'span',
            { className: 'text-right col-xs-5 col-md-5 col-lg-4 col-xlg-5 float-right category',
              'data-testid': '' + this.props.dataTest, id: '' + this.props.dataTest, role: "cell" },
            value
          )
        )
      );
    }
  }, {
    key: 'renderAsOfDateForCurrentSharePrice',
    value: function renderAsOfDateForCurrentSharePrice() {
      var _props3 = this.props,
          value = _props3.value,
          date = _props3.date,
          dataTest = _props3.dataTest;

      return value !== "-" && date && _react2.default.createElement(
        'span',
        { className: 'disclaimer font-dark-gray',
          'data-testid': dataTest + '-as-of-date', id: dataTest + '-as-of-date' },
        this.datePrefixLabel,
        _date_formatter2.default.getDateInSpecificFormat(date, "DD/MM/YYYY") + " " + _date_formatter2.default.getTimeInHoursAndMinutesInTimeZoneFormat(date, "UTC", true)
      );
    }
  }, {
    key: 'renderCurrentSharePrice',
    value: function renderCurrentSharePrice(backgroundRowColor) {
      return _react2.default.createElement(
        'div',
        { className: 'row padding-vertical-5 ' + backgroundRowColor },
        _react2.default.createElement(
          'div',
          { className: 'col-md-12 padding-left-0 padding-right-0 float-none' },
          _react2.default.createElement(
            'span',
            { className: 'text-left col-xs-7 col-md-7 col-lg-7 col-xlg-7 category white-space-nowrap',
              'data-testid': this.props.dataTest + '-label',
              id: this.props.dataTest + '-label' },
            this.props.label,
            ' ',
            this.renderIcon(this.props.labelText),
            _react2.default.createElement('br', null),
            this.renderAsOfDateForSingleFundStatsDataPoint()
          ),
          _react2.default.createElement(
            'span',
            { className: 'text-right col-xs-5 col-md-5 col-lg-5 col-xlg-5 float-right category',
              'data-testid': '' + this.props.dataTest,
              id: '' + this.props.dataTest },
            (0, _ramda.isNil)(this.props.value) ? "-" : this.props.value,
            typeof this.props.value === 'function' && this.props.value()
          )
        )
      );
    }
  }, {
    key: 'renderCompanyBrokerNames',
    value: function renderCompanyBrokerNames(backgroundRowColor) {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: 'row padding-vertical-5 ' + backgroundRowColor },
        _react2.default.createElement(
          'div',
          { className: 'col-md-12 padding-left-0 padding-right-0 float-none' },
          _react2.default.createElement(
            'span',
            { className: 'text-left col-xs-7 col-md-7 col-lg-7 col-xlg-7 category white-space-nowrap',
              'data-testid': this.props.dataTest + '-label',
              id: this.props.dataTest + '-label' },
            this.props.label
          ),
          _react2.default.createElement(
            'span',
            { className: 'text-right col-xs-5 col-md-5 col-lg-5 col-xlg-5 float-right category' },
            mapIndexed(function (companyBrokerName, i) {
              return _react2.default.createElement(
                'span',
                {
                  className: 'float-right col-xs-12 col-md-12 col-lg-12 col-xlg-12 font-small font-black-variant category',
                  key: i, 'data-testid': _this3.props.dataTest + '-company-broker-data-' + (i + 1),
                  id: _this3.props.dataTest + '-company-broker-data-' + (i + 1) },
                companyBrokerName
              );
            }, this.props.companyBrokerNames)
          )
        )
      );
    }
  }, {
    key: 'renderTrackingError',
    value: function renderTrackingError(backgroundRowColor) {
      var datapoints = [{
        label: _string_utility2.default.renderFormattedLabel('1Y', "pdp-fund-stats-tracking-error-one-year", { fundType: this.props.fundTypeCode }),
        dataTest: 'fund-stats-tracking-error-one-year',
        value: this.getAnnualTrackingErrorData("displayValue")
      }, {
        label: _string_utility2.default.renderFormattedLabel('3Y', "pdp-fund-stats-tracking-error-three-year", { fundType: this.props.fundTypeCode }),
        dataTest: 'fund-stats-tracking-error-three-year',
        value: this.getAnnualTrackingErrorData("displaySecondaryValue")
      }, {
        label: _string_utility2.default.renderFormattedLabel('5Y', "pdp-fund-stats-tracking-error-five-year", { fundType: this.props.fundTypeCode }),
        dataTest: 'fund-stats-tracking-error-five-year',
        value: this.getAnnualTrackingErrorData("displayTertiaryValue")
      }, {
        label: _string_utility2.default.renderFormattedLabel('Since Launch', "pdp-fund-stats-tracking-error-since-launch", { fundType: this.props.fundTypeCode }),
        dataTest: 'fund-stats-tracking-error-since-launch',
        value: this.getAnnualTrackingErrorData("displayQuarternaryValue")
      }];

      return _react2.default.createElement(
        'div',
        { className: backgroundRowColor },
        _react2.default.createElement(
          'div',
          { className: 'col-md-12 padding-left-0 padding-right-0 float-none' },
          _react2.default.createElement(
            'span',
            {
              className: 'text-left col-xs-7 col-md-7 col-lg-8 col-xlg-7 category white-space-nowrap',
              'data-testid': this.props.dataTest + '-label',
              id: this.props.dataTest + '-label',
              style: { zIndex: 1 }
            },
            _react2.default.createElement(
              'span',
              { className: 'white-space-default' },
              this.props.label,
              '\xA0',
              this.renderIcon(this.props.label)
            ),
            _react2.default.createElement('br', null),
            this.renderAsOfDateForSingleFundStatsDataPoint()
          )
        ),
        this.renderTrackingErrorDataPoint(datapoints)
      );
    }
  }, {
    key: 'renderTrackingErrorDataPoint',
    value: function renderTrackingErrorDataPoint(datapoints) {
      var result = [];
      datapoints.forEach(function (item) {
        result.push(_react2.default.createElement(
          'div',
          { className: 'col-md-12 padding-left-0 padding-right-0 float-none', role: "row" },
          _react2.default.createElement(
            'span',
            {
              className: 'text-left col-xs-7 col-md-7 col-lg-8 col-xlg-7 category white-space-nowrap',
              'data-testid': item.dataTest + '-label',
              id: item.dataTest + '-label',
              style: { zIndex: 1 },
              role: "rowheader"
            },
            _react2.default.createElement(
              'span',
              { className: 'white-space-default' },
              item.label
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'text-right col-xs-5 col-md-5 col-lg-4 col-xlg-5 float-right category',
              'data-testid': '' + item.dataTest, id: '' + item.dataTest, role: "cell" },
            item.value
          )
        ));
      });
      return result;
    }
  }, {
    key: 'getAnnualTrackingErrorData',
    value: function getAnnualTrackingErrorData(dataName) {
      var trackingErrorData = "-";
      if (!(0, _functional_utility.isNilOrEmpty)(this.props.value)) {
        if (this.props.value[dataName] !== "-") {
          trackingErrorData = _number_utility2.default.convertToAmountWithPreciseRounding(this.props.value[dataName]);
        }
      }
      return trackingErrorData;
    }
  }, {
    key: 'renderIntradayNavHeaderAndAsOfDate',
    value: function renderIntradayNavHeaderAndAsOfDate(asOfDate, intradayNavPrice, timeZone) {
      return _react2.default.createElement(
        'span',
        { className: 'text-left col-xs-7 col-md-7 col-lg-7 col-xlg-7 category', 'data-testid': this.props.dataTest + '-label', id: this.props.dataTest + '-label' },
        this.props.label,
        timeZone && _react2.default.createElement(
          'span',
          { className: 'disclaimer font-dark-gray', 'data-testid': this.props.dataTest + '-timeZone' },
          " (" + timeZone + " ",
          _string_utility2.default.renderFormattedLabel("time", "pdp-time-label"),
          ")"
        ),
        _react2.default.createElement('br', null),
        asOfDate && intradayNavPrice && _react2.default.createElement(
          'span',
          { className: 'disclaimer font-dark-gray', 'data-testid': this.props.dataTest + '-as-of-date', id: this.props.dataTest + '-as-of-date' },
          this.datePrefixLabel,
          asOfDate,
          _react2.default.createElement('br', null)
        )
      );
    }
  }, {
    key: 'renderIntraDayNavWithESTTimeZone',
    value: function renderIntraDayNavWithESTTimeZone(asOfDate, intradayNavPrice, backgroundRowColour) {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'row padding-vertical-5 ' + backgroundRowColour },
        _react2.default.createElement(
          'div',
          { className: 'col-md-12 padding-left-0 padding-right-0 float-none' },
          this.renderIntradayNavHeaderAndAsOfDate(asOfDate, intradayNavPrice),
          _react2.default.createElement(
            'span',
            { className: 'text-right col-xs-5 col-md-5 col-lg-5 col-xlg-5 float-right category' },
            mapIndexed(function (data, i) {
              return _react2.default.createElement(
                'span',
                {
                  className: 'float-right col-xs-12 col-md-12 col-lg-12 col-xlg-12 font-black-variant category',
                  key: i, 'data-testid': _this4.props.dataTest + '-nav-intraday-data-' + (i + 1), id: _this4.props.dataTest + '-nav-intraday-data-' + (i + 1) },
                _date_formatter2.default.getTimeInHoursAndMinutesInESTFormat(data.intraDayDateTime),
                ': ',
                _currency_utility2.default.convertToCurrencyWithoutDecimals(parseFloat(data.price).toFixed(4), _this4.props.currencyCode)
              );
            }, this.props.intraDayNav)
          )
        )
      );
    }
  }, {
    key: 'renderIntraDayNavWithLocalTimeZone',
    value: function renderIntraDayNavWithLocalTimeZone(asOfDate, intradayNavPrice, backgroundRowColour) {
      var _this5 = this;

      var decimalPlaces = !(0, _functional_utility.isNilOrEmpty)(this.props.visibleDataPoints) && (0, _ramda.includes)("INTRADAY_NAV_ROUNDING_TWO", this.props.visibleDataPoints) ? 2 : 4;

      return _react2.default.createElement(
        'div',
        { className: 'row padding-vertical-5 ' + backgroundRowColour },
        _react2.default.createElement(
          'div',
          { className: 'col-md-12 padding-left-0 padding-right-0 float-none' },
          this.renderIntradayNavHeaderAndAsOfDate(asOfDate, intradayNavPrice, this.props.intraDayNav.length > 0 ? this.props.intraDayNav[0].timeZone : null),
          _react2.default.createElement(
            'span',
            { className: 'text-right col-xs-5 col-md-5 col-lg-5 col-xlg-5 float-right category' },
            mapIndexed(function (data, i) {
              return _react2.default.createElement(
                'span',
                {
                  className: 'float-right col-xs-12 col-md-12 col-lg-12 col-xlg-12 font-small font-black-variant caption-intraday-nav-emea',
                  key: i, 'data-testid': _this5.props.dataTest + '-nav-intraday-data-' + (i + 1), id: _this5.props.dataTest + '-nav-intraday-data-' + (i + 1) },
                _date_formatter2.default.getTimeInHoursAndMinutesInTimeZoneFormat(data.intraDayDateTime, "UTC", true),
                ' ',
                _react2.default.createElement(_formatted_number2.default, { value: _currency_utility2.default.convertToCurrencyForNav(parseFloat(data.price).toFixed(decimalPlaces), _this5.props.currencyCode, _this5.props.fundTypeCode, _this5.props.country, decimalPlaces), numberFormat: _this5.props.numberFormat })
              );
            }, this.props.intraDayNav)
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.doNotRender()) {
        return null;
      }
      var backgroundRowColor = this.getRowStyleClasses(this.props);

      var intradaynavdDisplay = this.props.intraDayNav && this.props.intraDayNav.length > 0;

      if (intradaynavdDisplay) {
        var intradayNavPrice = this.props.intraDayNav[0].price;
        var asOfDate = _date_formatter2.default.getLocalFormattedDate(this.props.intraDayNav[0].intraDayDateTime, this.props.country);

        if (_collection_utility.CollectionUtility.includes(this.props.visibleFundStats, 'NAV_INTRADAY_WITH_LOCAL_TIMEZONE')) {
          return this.renderIntraDayNavWithLocalTimeZone(asOfDate, intradayNavPrice, backgroundRowColor);
        } else if (_collection_utility.CollectionUtility.includes(this.props.visibleFundStats, 'NAV_INTRADAY_WITH_EST_TIMEZONE')) {
          return this.renderIntraDayNavWithESTTimeZone(asOfDate, intradayNavPrice, backgroundRowColor);
        }
      }

      var companyBrokerNamesDisplay = this.props.companyBrokerNames && this.props.companyBrokerNames.length > 0;
      if (companyBrokerNamesDisplay) {
        return this.renderCompanyBrokerNames(backgroundRowColor);
      }

      var currentSharePriceDisplay = !(0, _ramda.isNil)(this.props.currentSharePrice);
      if (currentSharePriceDisplay) {
        return this.renderCurrentSharePrice(backgroundRowColor);
      }

      if (this.props.isTrackingError) {
        return this.renderTrackingError(backgroundRowColor);
      }

      return this.renderSingleFundStatsDataPoint(backgroundRowColor);
    }
  }], [{
    key: 'addPrintSuffix',
    value: function addPrintSuffix(keyStr, isPrint) {
      return '' + keyStr + (isPrint ? "-print" : "");
    }
  }]);

  return FundStatsDataPoint;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  this.getRowStyleClasses = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var classesToBeRemoved = props.removeClasses || [];
    var classesToBeAdded = props.addClasses || [];

    if (props.isSubHeaderTitle) {
      classesToBeRemoved.push("border-bottom-1");
      classesToBeRemoved.push("padding-vertical-10");
      classesToBeAdded.push("padding-top-10");
    }

    if (props.isNonLastSubRow) {
      classesToBeRemoved.push("border-bottom-1");
      classesToBeRemoved.push("padding-vertical-10");
    }

    if (props.isLastSubRow) {
      classesToBeRemoved.push("padding-vertical-10");
      classesToBeAdded.push("padding-bottom-10");
    }

    var defaultClasses = ["row", "margin-vertical-0", "margin-horizontal--30", "padding-vertical-10", "padding-horizontal-24", "border-bottom-1", "border-light-grey"].concat(_toConsumableArray(classesToBeAdded));

    return _string_utility2.default.concatNonEmptyStrings(defaultClasses.filter(function (c) {
      return !classesToBeRemoved.includes(c);
    }));
  };
};

exports.default = FundStatsDataPoint;